import { AsyncAction } from './AsyncAction';
import { AsyncScheduler } from './AsyncScheduler';
export var async = new AsyncScheduler(AsyncAction);
//# sourceMappingURL=async.js.map